import React from 'react';
import './styles.less';
import { NormalText, NumericText } from '@Src/commons/StyledComponent';
import COLOR from '@Src/commons/Colors';
import BambooFluentIcon from '@Src/commons/BambooFluentIcon';
import {
  ArrowDown16Regular,
  Clock12Regular,
  Timer12Regular,
} from '@fluentui/react-icons';
import { Col, Row, Tag } from 'antd';
import moment from 'moment';

type InvoiceCardType = {
  status: string;
  invoiceData: any;
};

export default function InvoiceCard({ status, invoiceData }: InvoiceCardType) {
  const getDueDateString = () => {
    const days = moment(invoiceData.documentDetails.invoiceData.dueOn).diff(
      moment(),
      'days'
    );
    if (days <= 0)
      return `Due on ${moment(
        invoiceData.documentDetails.invoiceData.dueOn
      ).format('DD MMM YYYY')}`;
    return `Due in ${Math.abs(days)} Days`;
  };
  return (
    <div className={`invoice-card ${status} screen-width`}>
      <Row justify="space-between">
        <div>
          <NormalText
            color={status == 'pending' ? COLOR.DAHILA_YELLOW : COLOR.MOSS_GREEN}
            fontSize={14}
            fontWeight={600}
          >
            {invoiceData.documentDetails.invoiceData.documentNumber}
          </NormalText>
          <NumericText
            color={
              status == 'pending' ? COLOR.PRIMARY_YELLOW : COLOR.PRIMARY_GREEN
            }
            fontSize={28}
            fontWeight={600}
          >
            INR {invoiceData.documentDetails.addItems.invoiceTotalValueWithTax}
          </NumericText>
        </div>
        <div className="inv-download-icon">
          {/* {invoiceData.fileUrl && (
            <a href={invoiceData.fileUrl || ''} download>
              <BambooFluentIcon
                icon={<ArrowDown16Regular style={{ color: COLOR.WHITE }} />}
              />
            </a>
          )} */}
        </div>
      </Row>
      <Row className="bottom-invoice-details">
        <Col>
          <Row className="mt-8">
            <Tag
              color={
                status == 'pending' ? COLOR.PRIMARY_YELLOW : COLOR.PRIMARY_GREEN
              }
            >
              <NormalText color={COLOR.WHITE} fontSize={10} fontWeight={400}>
                {status == 'pending' ? 'Acceptance Pending' : 'Accepted'}
              </NormalText>
            </Tag>
          </Row>
        </Col>
        <Col>
          <Row>
            <Col>
              <Row>
                {' '}
                <NormalText color={COLOR.GREY_8} fontSize={12} fontWeight={400}>
                  <BambooFluentIcon icon={<Timer12Regular />} />{' '}
                  {getDueDateString()}
                </NormalText>
              </Row>
              <Row>
                {' '}
                <NormalText color={COLOR.GREY_8} fontSize={12} fontWeight={400}>
                  <BambooFluentIcon icon={<Clock12Regular />} /> Created{' '}
                  {moment(invoiceData.createdAt).fromNow()}
                </NormalText>
              </Row>
              <Row className="mt-8">
                {' '}
                <NormalText
                  color={COLOR.GRAY_12}
                  fontSize={12}
                  fontWeight={400}
                >
                  Order No.{' '}
                  {invoiceData.documentDetails.invoiceData.referenceNumber}
                </NormalText>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
}
